import { useEffect, useState } from "react";
import { FaPowerOff, FaUserAlt } from "react-icons/fa";
import { MdOutlineAltRoute, MdOutlineSettings } from "react-icons/md";
import { NavLink, useNavigate } from "react-router-dom";
import { millisecondsToHMS, millisecondsToSeconds, deletealllocal } from "../../../utils/utils";
import IncomingCallPopup from './IncomingCallPopup';
import IncomingEmailPopup from "./IncomingEmailPopup";
import IncomingChatPopup from './IncomingChatPopup';
import LogoutPopup from "./LogoutPopup";
import CallStatus from './CallStatus';
import ChatStatus from './ChatStatus';
import EmailStatus from './EmailStatus';
import imagelogo from "./../../../assets/images/ccptextlogo.png";
import imageavatar from "./../../../assets/images/user1.png";
import { useDispatch, useSelector } from "react-redux";
import NextStatus from "./NextStatus";
import SoftphoneError from "./SoftphoneError";
import { chatSliceAction } from "../../../store/chatSlice"
import styled from "styled-components";
import NoWrapCode from "./NoWrapCode";
import { agentSliceAction } from "../../../store/agentSlice";
import londonStatus from "../../../config/LondonStatus.json";
import standardStatus from "../../../config/standardStatus.json";

const LogoutDisabler = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9999;
    background-color: #3c3c3c;
    opacity: 0.5;
`;

const Header = () => {
    const dispatch = useDispatch();
    const agentObj = useSelector((state: any) => { return state.agentSlice.agentObj })
    const agentSnapshot = useSelector((state: any) => { return state.agentSlice.agentSnapshot })
    const agentState = agentSnapshot?.agentData?.snapshot?.agentAvailabilityState?.state;
    const [agentStates, setAgentStates] = useState<any>("");
    const [agentName, setAgentName] = useState<any>("");
    const [routingProfile, setRoutingProfile] = useState<any>("");
    const [stateDuration, setStateDuration] = useState("");
    const contactAttributes = useSelector((state: any) => { return state.contactAttributeSlice?.contactAttributes })
    const selectedContact = contactAttributes?.filter((item: any) => !item.contactAttributes.hasOwnProperty("TicketNumber"))
    const isMonitoring = useSelector((state: any) => { return state.agentSlice.isMonitoring })

    let validStatus: string[] = [];
    const isLondonRegion = process.env.REACT_APP_AWS_CCP_REGION === "eu-west-2";

    if (isLondonRegion && routingProfile.name !== undefined) {
        londonStatus.forEach(obj => {
            if (obj["routingProfiles"].includes(routingProfile.name)) {
                validStatus = obj["status"];
            }

            if (obj["accountName"] === "Default" && validStatus.length === 0) {
                validStatus = obj["status"];
            }
        });
    } else if (standardStatus["regions"].includes(process.env.REACT_APP_AWS_CCP_REGION!)) {
        validStatus = standardStatus["status"];
    }

    useEffect(() => {
        if (agentObj) {
            setAgentStates(agentObj.getAgentStates())
            setAgentName(agentObj.getName())
            setRoutingProfile(agentObj.getRoutingProfile())

            agentObj.onRefresh(() => {
                if (agentObj.getNextState()) {
                    localStorage.setItem("scheduledNextStateName", agentObj.getNextState().name)
                }
                setAgentStates(agentObj.getAgentStates())
                setAgentName(agentObj.getName())
                setRoutingProfile(agentObj.getRoutingProfile())

                var existingValues = localStorage.getItem("agentStateTimer")
                var scheduledNextState = localStorage.getItem("scheduledNextState")
                var scheduledNextStateName = localStorage.getItem("scheduledNextStateName")

                if (scheduledNextState && scheduledNextState !== "0" && !agentObj.getNextState() && existingValues && scheduledNextStateName) {
                    var x = localStorage.getItem("scheduledNextState")
                    var oldTimer = parseInt(x || "0")
                    var newTimer = Date.now();

                    var timeInMillis = newTimer - oldTimer;
                    var timeInSeconds = millisecondsToSeconds(timeInMillis)

                    localStorage.setItem("recoveredTime", timeInSeconds.toString())
                    localStorage.setItem("scheduledNextState", "0")


                    let existingData = JSON.parse(existingValues);
                    console.log("Agent status change" + scheduledNextStateName)

                    if (scheduledNextStateName === 'Lunch') {
                        console.log("Previous lunch time: " + existingData['Lunch'])
                        console.log("Previous lunchuse time: " + existingData[''])
                        console.log("Time to be added: " + timeInSeconds)
                        existingData['Lunch'] += timeInSeconds;
                        existingData['Lunchused'] -= timeInSeconds;
                        console.log("New lunch time (added recovered): " + existingData['Lunch'])
                        console.log("New lunchused time (rest recovered): " + existingData['Lunchused'])

                        console.log("Agent no longer has a next status. Elapsed seconds: " + timeInSeconds)
                    } else if (scheduledNextStateName === 'Break') {

                        console.log("Previous break time: " + existingData['Break'])
                        console.log("Previous breakused time: " + existingData['Breakused'])
                        existingData['Break'] += timeInSeconds;
                        existingData['Breakused'] -= timeInSeconds;
                        console.log("New break time (added recovered): " + existingData['Break'])
                        console.log("New breakused time (rest recovered): " + existingData['Breakused'])

                        console.log("Agent no longer has a next status. Elapsed seconds: " + timeInSeconds)
                    }
                }
            })

            agentObj.onEnqueuedNextState(() => {
                localStorage.setItem("scheduledNextState", Date.now().toString())
                localStorage.setItem("recoveredTime", "0")
                console.log("Agent has next status")
            })


            let interval = setInterval(() => {
                let durationInMillis = agentObj.getStateDuration()
                const hms = millisecondsToHMS(durationInMillis)
                setStateDuration(hms)
            }, 1000);
            return () => {
                clearInterval(interval)
            }
        }
    }, [agentObj])



    const onAgentStatusChange = (status: any) => {

        let agentCurrentState = agentObj.getState().name
        if (agentCurrentState === "Busy") {
            dispatch(chatSliceAction.changeisEmailMissed({ isEmailMissed: false }));
            dispatch(chatSliceAction.changeisEmailRejected({ isEmailRejected: false }));
            dispatch(chatSliceAction.changeIsItRejected({ isItRejected: false }));
            dispatch(chatSliceAction.changeIsItMissed({ isItMissed: false }));
            document.title = `[${agentState}] Fujitsu Connect`;
            agentObj.setStatus(status, {



                success: function () {
                    let existingValues = localStorage.getItem("agentStateTimer");

                    if (existingValues) {
                        let existingData = JSON.parse(existingValues);
                        existingData[`StartTime${status.name}`] = Math.floor(Date.now() / 1000)
                        localStorage.setItem("agentStateTimer", JSON.stringify(existingData))
                    }
                    console.log("Agent Status Change Successfully -" + status.name);
                },
                failure: function (err: any) {
                    console.log("Agent Status Change Failed -" + status.name + err);
                }
            },
                { enqueueNextState: true },
            )
        } else {

            dispatch(chatSliceAction.changeisEmailMissed({ isEmailMissed: false }));
            dispatch(chatSliceAction.changeisEmailRejected({ isEmailRejected: false }));
            dispatch(chatSliceAction.changeIsItRejected({ isItRejected: false }));
            dispatch(chatSliceAction.changeIsItMissed({ isItMissed: false }));
            if (!selectedContact.length || process.env.REACT_APP_AWS_CCP_MandatoryWrap === "0" || isMonitoring) {
                if (agentState !== status.name) {
                    document.title = `[${agentState}] Fujitsu Connect`;

                    agentObj.setStatus(status, {
                        success: () => {

                            let existingValues = localStorage.getItem("agentStateTimer");

                            if (existingValues) {
                                let existingData = JSON.parse(existingValues);
                                existingData[`StartTime${status.name}`] = Math.floor(Date.now() / 1000)

                                if (!existingData[status.name + "used"] || existingData[status.name + "used"] > 0) {
                                    existingData[status.name + "used"] += existingData[status.name]
                                }
                                if (!existingData[agentState + "used"]) {
                                    existingData[agentState + "used"] += existingData[agentState]
                                    existingData[agentState] = 0
                                }

                                localStorage.setItem("agentStateTimer", JSON.stringify(existingData))
                            }
                            console.log("Agent Status Change Successfully -" + status.name)
                        },
                        failure: () => {
                            console.log("Agent Status Change Failed -" + status.name)
                        }
                    },
                        { enqueueNextState: true })
                }
                dispatch(agentSliceAction.setMonitoring({ isMonitoring: false }));
            } else {
                dispatch(agentSliceAction.setIsMissingWrapCode({ MissingWrapCode: true }));
            }
        }
    }

    const onAgentLogout = async () => {
        localStorage.removeItem('missedContacsAgent');
        localStorage.removeItem('missedChatsAgent');
        deletealllocal("ShortDescriptions")
        deletealllocal("ChatDrafts")
        if (agentState === "Offline") {
            await fetch(`${process.env.REACT_APP_AWS_CCP_URL}`.replace("/ccp-v2/", "") + "/logout", { credentials: "include", mode: "no-cors" }).then(() => window.location.reload())
        } else {
            console.log("You're not offline")
            return false;
        }
    }

    return (
        <header className="app-header fixed-top">
            <div className="navbar-header">
                <div className='d-flex'>
                    <div className='app-logo'>
                        {/* Adding the possibility to click on Fujitsu logo and then be redirected to the dashboard */}
                        <NavLink className={({ isActive }) => (isActive ? 'inactive' : 'inactive')} to="/dashboard">
                            <img className='logo-src' src={imagelogo} alt="Header logo" />
                        </NavLink>
                    </div>
                    <SoftphoneError />
                </div>

                <div className='d-flex'>
                    <CallStatus />
                    <ChatStatus />
                    <EmailStatus />
                    <NextStatus />
                    <IncomingCallPopup />
                    <IncomingEmailPopup />
                    <IncomingChatPopup />
                    <LogoutPopup />
                    <NoWrapCode />
                </div>
                <div className='d-flex align-items-center'>
                    <div className='me-3'>

                    </div>
                    <div className="dropdown">
                        <button type="button" className={`btn btn-sm dropdown-toggle ${(agentState === "Available") ? "btn-outline-success" : (agentState === "Offline") ? "btn-outline-danger" : "btn-outline-orange"}`} data-bs-toggle="dropdown">
                            <i className={`fas fa-circle fa-sm fa-fw mr-2 ${(agentState === "Available") ? "text-success" : (agentState === "Offline") ? "text-danger" : "text-orange"}`}></i>
                            {agentState}
                        </button>
                        <ul className="dropdown-menu">
                            {isLondonRegion ? (
                                agentStates && agentStates.sort((a: any, b: any) => validStatus.indexOf(a.name) - validStatus.indexOf(b.name)).map((state: any, index: number) => {
                                    if (validStatus.includes(state.name) || validStatus.length === 0) {
                                        return (
                                            <li key={index}>
                                                <button onClick={() => { onAgentStatusChange(state) }} className="dropdown-item">
                                                    <i className={`fas fa-circle fa-sm fa-fw mr-2 ${(state.name === "Available") ? "text-success" : (state.name === "Offline") ? "text-danger" : "text-orange"}`}></i>
                                                    {state.name}
                                                </button>
                                            </li>
                                        )
                                    }
                                })
                            ) : (
                                agentStates && agentStates.map((state: any, index: number) => (
                                    <li key={index}>
                                        <button onClick={() => { onAgentStatusChange(state) }} className="dropdown-item">
                                            <i className={`fas fa-circle fa-sm fa-fw mr-2 ${(state.name === "Available") ? "text-success" : (state.name === "Offline") ? "text-danger" : "text-orange"}`}></i>
                                            {state.name}
                                        </button>
                                    </li>
                                ))
                            )}
                        </ul>
                    </div>
                    {(agentState != "Offline") &&
                        <div className='time ms-3'>{stateDuration}</div>
                    }
                    <div className="dropdown d-inline-block">
                        <button type="button" className="btn header-item user text-start d-flex align-items-center" data-bs-toggle="dropdown">
                            <img className={`rounded-circle header-profile-user border ${(agentState === "Available") ? "border-success" : "border-danger"}`} src={imageavatar} alt="Header avatar" />
                        </button>
                        <ul className="dropdown-menu dropdown-effect">
                            <li><button className="dropdown-item"><FaUserAlt size={14} /> {agentName} </button></li>
                            <li><button className="dropdown-item"><MdOutlineAltRoute size={14} /> {routingProfile.name} </button></li>
                            <li><NavLink className="dropdown-item" to="/setting"><MdOutlineSettings size={14} /> Settings </NavLink></li>
                            <li><hr className="dropdown-divider" /></li>
                            <li><button className={`dropdown-item ${(agentState !== "Offline") ? "disabled" : ""}`} onClick={() => { onAgentLogout() }} ><FaPowerOff size={14} /> Logout</button></li>
                        </ul>
                    </div>
                </div>
            </div>
        </header>
    );
}
export default Header;